<script setup lang="ts">
import { Tag } from '@/types/api/api-v3/product'

type Props = {
  filter: Tag
  isActiveFilter: boolean
  isPossibleFilter: boolean
  isFiltersActivated: boolean
}

const props = defineProps<Props>()

const emit = defineEmits(['setActiveFilter', 'deactivateFilter'])

const { isDesktop } = useResponsive()

const isFilterDisabled = computed(() => {
  return (
    props.isFiltersActivated && !props.isActiveFilter && !props.isPossibleFilter
  )
})

const filterFontWeight = computed(() => {
  return isDesktop.value ? 'semi-bold' : 'extra-bold'
})

const filterSize = computed(() => {
  return isDesktop.value ? 'md' : 'sm'
})

const toggleFilterState = () => {
  if (props.isActiveFilter) {
    emit('deactivateFilter', props.filter)
  } else {
    emit('setActiveFilter', props.filter)
  }
}
</script>

<template>
  <the-chip
    :active="isActiveFilter"
    :disabled="isFilterDisabled"
    :weight="filterFontWeight"
    :size="filterSize"
    @click="toggleFilterState"
  >
    {{ filter.name }}
  </the-chip>
</template>
